<template>
  <div class="page-bg">
    <div class="card search-card">
      <!-- 搜索区域 -->
      <el-form size="small" label-width="100px" class="margin15-tb" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="公司名称">
              <el-select v-model="search.companyId" placeholder="请选择公司" clearable @change="onSearchCompanyChange" filterable style="width: 100%">
                <el-option v-for="item in searchCompanyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="策略组名称">
              <el-select v-model="search.groupId" placeholder="请选择策略组" clearable  filterable style="width: 100%">
                <el-option v-for="item in searchGroupList" :key="item.id" :label="item.groupName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="display:flex;justify-content:flex-end;align-items:center;margin-left:-60px;">
            <el-button type="primary" @click="handleSearch" style="margin-right:8px;">
              <i class="el-icon-search" style="margin-right:4px;"></i>搜索
            </el-button>
            <el-button @click="handleReset">
              <i class="el-icon-refresh" style="margin-right:4px;"></i>重置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="card table-card">
      <!-- 添加按钮 -->
      <div class="table-header">
        <el-button type="primary" icon="el-icon-plus" size="small"  @click="handleAdd">添加</el-button>
      </div>
      <!-- 表格区域 -->
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        style="width:100%"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column prop="companyName" label="复制公司" align="center" />
        <el-table-column prop="targetCompanyName" label="跟进公司" align="center" />
        <el-table-column prop="groupName" label="策略组名称" align="center" />
        <el-table-column prop="targetGroupName" label="跟进策略组名称" align="center" />
        <el-table-column prop="conditional" label="跟进条件" align="center" />
        <el-table-column prop="targetUserId" label="目标用户" align="center" />
        <el-table-column prop="timingTime" label="发送间隔时间（分钟）" align="center" />
        <el-table-column prop="callTimes" label="未接通次数" align="center" />
        <el-table-column prop="isOpenTiming" label="是否开启指定时间段复制" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.isOpenTiming ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="timeRange" label="时间范围" align="center">
          <template slot-scope="scope">
            <span v-if="Array.isArray(scope.row.timeRange)">
              {{ scope.row.timeRange[0] }} ~ {{ scope.row.timeRange[1] }}
            </span>
            <span v-else>
              {{ scope.row.timeRange ? scope.row.timeRange.replace(',', ' ~ ').replace('-', ' ~ ') : '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" />
        <el-table-column prop="status" label="是否开启配置" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="true"
              :inactive-value="false"
              @change="val => handleStatusChange(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">
              <i class="el-icon-edit" style="margin-right:4px;"></i>编辑
            </el-button>
            <el-button type="text" size="small" style="color: red;" @click="handleDelete(scope.row)">
              <i class="el-icon-delete" style="margin-right:4px;"></i>删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 16px; text-align: center"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>
    <!-- 添加弹窗 -->
    <el-dialog title="添加配置" :visible.sync="dialogVisible" width="750px" @close="resetDialog" custom-class="center-dialog">
      <el-form :model="form" label-width="90px" label-position="left" style="margin-top:10px;" :rules="rules" ref="formRef">
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="公司" prop="companyId" :required="true">
              <el-select v-model="form.companyId" placeholder="请选择公司" @change="onCompanyChange" :disabled="isEdit" style="width:220px" filterable>
                <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="策略组" prop="groupId" :required="true">
              <el-select v-model="form.groupId" placeholder="请选择策略组" style="width:220px" :disabled="isEdit" filterable>
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="跟进公司" prop="targetCompanyId" :required="true">
              <el-select v-model="form.targetCompanyId" placeholder="请选择跟进公司" @change="onTargetCompanyChange" style="width:220px" filterable>
                <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跟进策略组" prop="targetGroupId">
              <el-select v-model="form.targetGroupId" placeholder="请选择跟进策略组" style="width:220px" filterable>
                <el-option v-for="item in targetGroupList" :key="item.id" :label="item.groupName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="跟进条件">
              <el-input v-model="form.conditional" placeholder="请输入跟进条件" style="width:220px" />
              <div style="color:#f56c6c;font-size:12px;margin-top:2px;">多个条件之间使用英文分号连接</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发送间隔(分钟)">
              <el-input-number v-model="form.timingTime" :min="0" style="width:220px"
                @change="validateTimingTime"
              />
              <el-tooltip content="案件复制后间隔多长时间发送,单位:分钟" placement="top">
                <i class="el-icon-question" style="margin-left:6px;color:#999;cursor:pointer;"></i>
              </el-tooltip>
              <div v-if="timingTimeError" style="color:#f56c6c;font-size:12px;margin-top:2px;">{{ timingTimeErrorMsg }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="未接通次数">
              <el-input v-model="form.callTimes" placeholder="请输入未接通次数" style="width:220px" @input="validateCallTimes" />
              <el-tooltip content="若配置了未接通标签，则需要填写该案件外呼达多少次才进行复制" placement="top">
                <i class="el-icon-question" style="margin-left:6px;color:#999;cursor:pointer;"></i>
              </el-tooltip>
              <div v-if="callTimesError" style="color:#f56c6c;font-size:12px;margin-top:2px;">{{ callTimesErrorMsg }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目标用户" :required="true">
              <el-select
                v-model="form.targetUserId"
                placeholder="请选择目标用户"
                style="width:220px"
                clearable
              >
                <el-option v-for="item in targetUserList" :key="item.id" :label="item.userName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增：是否开启配置 和 是否开启指定时段 -->
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="是否开启配置">
              <el-switch
                v-model="form.status"
                :active-value="true"
                :inactive-value="false"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开启指定时段">
              <el-switch v-model="form.isOpenTiming" @change="onIsOpenTimingChange" />
              <el-tooltip content="点击开启后,只会复制该策略组选择的时间段的案件" placement="top">
                <i class="el-icon-question" style="margin-left:6px;color:#999;cursor:pointer;"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8" v-if="form.isOpenTiming">
          <el-col :span="24">
            <el-form-item label="时间段">
              <el-time-picker
                v-model="form.startTime"
                placeholder="开始时间"
                format="HH:mm"
                value-format="HH:mm"
                style="width:150px;margin-right:8px;"
              />
              <span style="margin:0 8px;">至</span>
              <el-time-picker
                v-model="form.endTime"
                placeholder="结束时间"
                format="HH:mm"
                value-format="HH:mm"
                style="width:150px"
              />
              <div v-if="timeRangeError" style="color:#f56c6c;font-size:12px;margin-top:2px;">{{ timeRangeErrorMsg }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="dialog-footer-center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      list: [], // 当前展示数据
      search: {
        companyId: '',
        groupId: ''
      },
      dialogVisible: false,
      form: {
        companyId: '',
        groupId: '',
        targetCompanyId: '',
        targetGroupId: '',
        timingTime: 0,
        conditional: '',
        callTimes: '',
        isOpenTiming: false,
        startTime: '',
        endTime: '',
        targetUserId: '',
        status: true // 新增
      },
      companyList: [],
      groupList: [],
      targetGroupList: [],
      isEdit: false,
      timingTimeError: false,
      timingTimeErrorMsg: '', // 新增：发送间隔时间错误提示
      targetUserList: [], // 新增：目标公司用户列表
      callTimesError: false,
      callTimesErrorMsg: '',
      // 新增：时间段校验
      timeRangeError: false,
      timeRangeErrorMsg: '',
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      rules: {
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择策略组', trigger: 'change' }],
        targetCompanyId: [{ required: true, message: '请选择跟进公司', trigger: 'change' }]
      },
      searchCompanyList: [], // 搜索用公司列表
      searchGroupList: [] // 搜索用策略组列表
    };
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$ajax({
        url: '/copyConfig/list',
        method: 'POST',
        data: {
          start: (this.currentPage - 1) * this.pageSize,
          limit: this.pageSize,
          companyId: this.search.companyId,
          groupId: this.search.groupId
        }
      }).then((res) => {
        const data = res.data.list || res.data || [];
        this.list = data;
        this.total = res.data.totalRecords || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    handleReset() {
      this.search.companyId = '';
      this.search.groupId = '';
      this.searchGroupList = [];
      this.currentPage = 1;
      this.fetchList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchList();
    },
    handleAdd() {
      this.dialogVisible = true;
      this.isEdit = false;
      this.getCompanyList();
    },
    resetDialog() {
      this.form = {
        companyId: '',
        groupId: '',
        targetCompanyId: '',
        targetGroupId: '',
        timingTime: 0,
        conditional: '',
        callTimes: '',
        isOpenTiming: false,
        startTime: '',
        endTime: '',
        targetUserId: '',
        status: true // 新增
      };
      this.groupList = [];
      this.targetGroupList = [];
      this.isEdit = false;
      this.callTimesError = false;
      this.callTimesErrorMsg = '';
      this.timeRangeError = false;
      this.timeRangeErrorMsg = '';
      this.timingTimeError = false;
      this.timingTimeErrorMsg = '';
    },
    getCompanyList() {
      this.$ajax({ url: '/company/getAllValidCompany', method: 'GET' }).then((res) => {
        this.companyList = res.data || [];
      });
    },
    async onCompanyChange(val, groupId) {
      this.form.groupId = '';
      this.groupList = [];
      if (val) {
        const res = await this.$ajax({ url: `/strategy/list/${val}`, method: 'GET' });
        this.groupList = res.data || [];
        if (groupId) {
          this.form.groupId = groupId;
        }
      }
    },
    async onTargetCompanyChange(val, targetGroupId) {
      this.form.targetGroupId = '';
      this.targetGroupList = [];
      this.targetUserList = [];
      if (val) {
        const res = await this.$ajax({ url: `/strategy/list/${val}`, method: 'GET' });
        this.targetGroupList = res.data || [];
        if (targetGroupId) {
          this.form.targetGroupId = targetGroupId;
        }
        // 新增：获取目标公司用户列表
        this.$ajax({ url: `/copyConfig/getAllUser/${val}`, method: 'GET' }).then((response) => {
          this.targetUserList = response.data || [];
        });
      }
    },
    handleDialogConfirm() {
      // 新增：发送间隔时间校验
      if (this.form.timingTime === '' || this.form.timingTime === null || this.form.timingTime === undefined) {
        this.timingTimeError = true;
        this.timingTimeErrorMsg = '发送间隔时间不能为空';
        this.$message.warning('发送间隔时间不能为空');
        return;
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        // 时间段校验
        if (this.form.isOpenTiming) {
          if (!this.form.startTime || !this.form.endTime) {
            this.timeRangeError = true;
            this.timeRangeErrorMsg = '请选择完整的时间段';
            this.$message.warning('请选择完整的时间段');
            return;
          }
          if (this.form.startTime >= this.form.endTime) {
            this.timeRangeError = true;
            this.timeRangeErrorMsg = '开始时间不能大于或等于结束时间';
            this.$message.warning('开始时间不能大于或等于结束时间');
            return;
          }
          this.form.timeRange = `${this.form.startTime},${this.form.endTime}`;
        } else {
          // 关闭时清空时间段
          this.form.startTime = '';
          this.form.endTime = '';
          this.form.timeRange = '';
        }
        this.timeRangeError = false;
        this.timeRangeErrorMsg = '';
        // 校验未接通次数
        this.callTimesError = false;
        this.callTimesErrorMsg = '';
        // 新增：未接通次数为1时提示
        if (String(this.form.callTimes).trim() === '1') {
          this.$message.warning('未接通次数为1时，该策略不生效');
          return;
        }
        // 获取公司和策略组名称
        const company = this.companyList.find(item => item.id === this.form.companyId);
        const group = this.groupList.find(item => item.id === this.form.groupId);
        const targetCompany = this.companyList.find(item => item.id === this.form.targetCompanyId);
        const targetGroup = this.targetGroupList.find(item => item.id === this.form.targetGroupId);

        this.form.companyName = company ? company.companyName : '';
        this.form.groupName = group ? group.groupName : '';
        this.form.targetCompanyName = targetCompany ? targetCompany.companyName : '';
        this.form.targetGroupName = targetGroup ? targetGroup.groupName : '';

        // 保证目标用户ID为数字类型
        this.form.targetUserId = Number(this.form.targetUserId) || '';

        // 合并时间为字符串 timeRange
        if (this.form.startTime && this.form.endTime) {
          this.form.timeRange = `${this.form.startTime},${this.form.endTime}`;
        } else {
          this.form.timeRange = '';
        }
        delete this.form.startTime;
        delete this.form.endTime;

        // 判断是新增还是编辑
        let url = '';
        if (this.isEdit) {
          url = '/copyConfig/update';
        } else {
          url = '/copyConfig/add';
        }
        // 提交表单到对应接口
        this.$ajax({
          url,
          method: 'POST',
          data: this.form
        }).then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '添加成功');
          this.dialogVisible = false;
          this.resetDialog();
          this.fetchList();
        });
      });
    },
    async handleEdit(row) {
      // 编辑
      this.dialogVisible = true;
      this.isEdit = true;
      this.form = {
        ...row,
        startTime: row.timeRange ? row.timeRange.split(',')[0] : '',
        endTime: row.timeRange ? row.timeRange.split(',')[1] : '',
        callTimes: row.callTimes || '',
        status: typeof row.status === 'boolean' ? row.status : true // 新增
      };
      await this.getCompanyList();
      await this.onCompanyChange(row.companyId, row.groupId);
      await this.onTargetCompanyChange(row.targetCompanyId, row.targetGroupId);
      // 新增：拉取目标公司用户列表
      if (row.targetCompanyId) {
        this.$ajax({ url: `/copyConfig/getAllUser/${row.targetCompanyId}`, method: 'GET' }).then((res) => {
          this.targetUserList = res.data || [];
        });
      }
    },
    handleDelete(row) {
      this.$confirm('确定要删除该配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/copyConfig/delete',
          method: 'POST',
          data: { id: row.id, configStatus: false }
        }).then(() => {
          this.$message.success('删除成功');
          // 删除后判断是否需要跳转到上一页
          const totalAfterDelete = this.total - 1;
          const maxPage = Math.ceil(totalAfterDelete / this.pageSize) || 1;
          if (this.currentPage > maxPage) {
            this.currentPage = maxPage;
          }
          this.fetchList();
        });
      }).catch(() => {
        // 用户取消，无需处理
      });
    },
    handleStatusChange(row, val) {
      const data = {
        ...row,
        status: val
      };
      this.$ajax({
        url: '/copyConfig/update',
        method: 'POST',
        data
      }).then(() => {
        this.$message.success('状态更新成功');
        this.fetchList();
      }).catch(() => {
        this.$message.error('状态更新失败');
        // 回滚状态
        row.status = !val;
      });
    },
    headerCellStyle() {
      return {
        background: '#eef3ff',
        color: '#333',
        fontWeight: 'normal',
        textAlign: 'center'
      };
    },
    cellStyle() {
      return {
        textAlign: 'center'
      };
    },
    validateTimingTime(val) {
      // 只允许数字
      if (val === '' || val === null || val === undefined) {
        this.timingTimeError = true;
        this.timingTimeErrorMsg = '发送间隔时间不能为空';
        return;
      }
      const isNum = /^\d+$/.test(String(val));
      this.timingTimeError = !isNum;
      if (!isNum) {
        this.timingTimeErrorMsg = '只能输入数字';
        this.form.timingTime = String(val).replace(/\D/g, '');
      } else {
        this.timingTimeErrorMsg = '';
      }
    },
    validateCallTimes(val) {
      // 只允许输入非负整数
      if (val === '' || val === null) {
        this.callTimesError = false;
        this.callTimesErrorMsg = '';
        return;
      }
      // 过滤非数字和负号
      const filtered = val.replace(/[^\d]/g, '');
      if (filtered !== val) {
        this.form.callTimes = filtered;
        this.callTimesError = true;
        this.callTimesErrorMsg = '未接通次数只能输入非负整数';
        return;
      }
      // 检查是否为负数
      if (/^-/.test(val) || Number(val) < 0) {
        this.form.callTimes = filtered;
        this.callTimesError = true;
        this.callTimesErrorMsg = '未接通次数不能为负数';
        return;
      }
      this.callTimesError = false;
      this.callTimesErrorMsg = '';
    },
    getSearchCompanyList() {
      this.$ajax({ url: '/company/getAllValidCompany', method: 'GET' }).then((res) => {
        this.searchCompanyList = res.data || [];
      });
    },
    onSearchCompanyChange(val) {
      this.search.groupId = '';
      this.searchGroupList = [];
      if (val) {
        this.$ajax({ url: `/strategy/list/${val}`, method: 'GET' }).then((res) => {
          this.searchGroupList = res.data || [];
        });
      }
    },
    onIsOpenTimingChange(val) {
      if (!val) {
        this.form.startTime = '';
        this.form.endTime = '';
        this.form.timeRange = '';
      }
    }
  },
  mounted() {
    this.fetchList();
    this.getSearchCompanyList();
  }
};
</script>

<style scoped>
.page-bg {
  background: #f5f7fa;
  min-height: 100vh;
  padding: 24px;
}
.card {
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
  margin-bottom: 24px;
  padding: 24px;
}
.search-card {
  margin-bottom: 16px;
}
.table-card {
  padding-top: 16px;
}
.table-header {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.center-dialog .el-dialog__header {
  text-align: center;
}
.dialog-footer-center {
  display: flex;
  justify-content: center;
  gap: 16px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/system/config.vue